import "./financingStyles.scss";
import { Link } from "react-router-dom";
import { routes } from "../../routes/RoutesComponent";
import { FC } from "react";
import { trackEvent } from "../../../../lib/analytics";

interface financingProps {
    bgColor: string;
    textColor: string;
    redirectButton?: boolean;
    /** Superficie donde se mostró el banner, para comparar cuál convierte. */
    origen?: "catalogo" | "home" | "pagina_financiacion";
}

export const Financing: FC<financingProps> = ({ bgColor, textColor, redirectButton = false, origen = "catalogo" }) => {
    return (
        <Link
            onClick={() =>
                trackEvent(
                    "financiacion_solicitada",
                    { origen, producto: redirectButton ? "credifacil" : "pagina_financiacion" },
                    { inmediato: redirectButton },
                )
            }
            to={
                redirectButton
                    ? "https://app.zapsign.com.br/verificar/doc/90e6334c-328d-4f5d-914b-03b16b15bde5"
                    : routes.services.relativePath
            }
            target={redirectButton && "_blank"}
            style={{ backgroundColor: bgColor }}
            className="financing col-md-12 position-relative text-black d-flex justify-content-center align-items-center"
        >
            <img
                className="position-absolute wcar-icon"
                src="./assets/home/wcar_icon.svg"
                alt="Financiación hasta del 90%"
                title="Financiación hasta del 90%"
                loading="lazy"
                decoding="async"
            />
            <div className="d-flex justify-content-center align-items-center flex-wrap" style={{ margin: "0 10%" }}>
                <p style={{ color: textColor }} className="description text-center">
                    <strong>Financiación hasta</strong>
                    <span className="fst-italic"> del 100%</span>
                </p>
                <button className="btn-custom">EVALÚA TU CRÉDITO</button>
            </div>
        </Link>
    );
};
